import React from 'react';

const AboutSkills = ({ skills }) => {

  return (
    <div className="about__content-skills">
      <h3 className="about__content-title">My Skills</h3>
      <div className="skills">
        {skills.map((skill, index) => (
          <div key={index} className="skills__skill">
            <i
              className={skill.icon}
              style={{ fontSize: 40, marginRight: 12 }}
              title={skill.name}
            />
            <span>{skill.name || skill}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutSkills;